/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';
import { getAccessTokenSafely } from '../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';

const getGooglePhoto = async ({ photoReference }) => {
    const urlParamsArr = photoReference?.split('/');
    //Post api call to start playbook
    const wcEnv = {
        rootUri: '/',
    };
    
    const resourePath = `flowers-gpt/api/playbook?photo_reference=${urlParamsArr?.[3]}`;
    const token = await getAccessTokenSafely();
    const response = await restClient.getFacade(wcEnv, resourePath, token, null, null, false);
    return response;
};

export default getGooglePhoto;
